import {
    Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy
} from '@angular/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { PublicationCreator } from 'app/fs/res/publication/model/publication-creator';

const creatornameFormKey = 'creatorname';
const firstnameFormKey = 'firstname';
const nameprefixFormKey = 'nameprefix';
const namesuffixFormKey = 'namesuffix';

@Component( {
    selector: 'res-publication-creator-wizard-name',
    templateUrl: './publication-creator-wizard-name.component.html',
} )
export class PublicationCreatorWizardNameComponent implements OnChanges, OnDestroy {
    @Input() creator: PublicationCreator;
    @Output() creatorChange: EventEmitter<PublicationCreator> = new EventEmitter();
    @Output() creatorChangeConfirm: EventEmitter<PublicationCreator> = new EventEmitter();

    creatorNameForm: UntypedFormGroup;
    showNameChangeWarning = false;

    constructor( private fb: UntypedFormBuilder ) {
        this.createForm();
    }

    ngOnChanges( changes: SimpleChanges ) {
        let changesKey = 'creator';
        if ( changes[changesKey].currentValue.creatorname !== undefined ) {
            this.setFormValuesFromCreator();
        }
    }

    public onChange() {
        this.setCreatorNameFromFormValues();
        this.creatorChange.emit( this.creator );
    }

    public onKeyDownEnter() {
        this.setCreatorNameFromFormValues();
        this.creatorChangeConfirm.emit( this.creator);
    }

    private setCreatorNameFromFormValues() {
        this.creator.creatorname = this.creatorNameForm.controls[creatornameFormKey].value?.trim();
        this.creator.firstname = this.creatorNameForm.controls[firstnameFormKey].value?.trim();
        this.creator.nameprefix = this.creatorNameForm.controls[nameprefixFormKey].value?.trim();
        this.creator.namesuffix = this.creatorNameForm.controls[namesuffixFormKey].value?.trim();
    }

    private setFormValuesFromCreator() {
        this.creatorNameForm.controls[creatornameFormKey].setValue( this.creator.creatorname );
        this.creatorNameForm.controls[firstnameFormKey].setValue( this.creator.firstname );
        if ( this.creator.nameprefix ) {
            this.creatorNameForm.controls[nameprefixFormKey].setValue( this.creator.nameprefix );
        } else {
            this.creatorNameForm.controls[nameprefixFormKey].setValue( '' );
        }
        if ( this.creator.namesuffix ) {
            this.creatorNameForm.controls[namesuffixFormKey].setValue( this.creator.namesuffix );
        } else {
            this.creatorNameForm.controls[namesuffixFormKey].setValue( '' );
        }
    }

    private resetCreatorPersonAndOrganization() {
        this.creator.person = null;
        this.creator.creatorOrganizations = [];
    }

    public createForm() {
        this.creatorNameForm = this.fb.group( {
            creatorname: ['', Validators.required],
            firstname: ['', Validators.required],
            namesuffix: [''],
            nameprefix: ['']
        } );
    }

    public isEditCreator() {
        console.log( ( this.creator.person !== null || undefined ) || this.creator.creatorOrganizations?.length > 0 );
        return ( this.creator.person || this.creator.creatorOrganizations?.length > 0 );
    }

    ngOnDestroy() {
        this.creatorNameForm.reset();
    }
}
